import { createReducer, on } from '@ngrx/store';
import { initialUserState } from './user.state';
import * as UserActions from './user.actions';
export const userReducer = createReducer(
  initialUserState,

  on(UserActions.loginSuccess, (_, { user }) => ({
    name: user.name,
    email: user.email,
    phone: user.phone,
    roleName: user.roleName,
    roleCode: user.roleCode,
    uuid: user.uuid,
    vehicleTypes: user.vehicleTypes,
    selectedVehicle: user.vehicleTypes[0] || null,
  })),

  on(UserActions.updateSelectedVehicle, (state, { vehicle }) => {
    if (!state) return null;
    return { ...state, selectedVehicle: vehicle };
  }),

  on(UserActions.updateAboutMe, (state, { user }) => {
    if (!state) return null;
    return { ...state, name: user.name, email: user.email, phone: user.phone };
  }),

  on(UserActions.logout, () => null)
);
